import { html, strMap } from 'fxjs/es';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessAppPlusProductTmplS } from '../../../Product/S/Tmpl/module/NessAppPlusProductTmplS.js';
import { NessAppPlusHomeTmplS } from './module/NessAppPlusHomeTmplS.js';
import { NessCoreConstantS } from '../../../../../Core/S/Constant/module/NessCoreConstantS.js';

export const recentProduct = (recent_products, { is_mobile }) => {
  return html`
    <div class="ness-recent-product">
      ${NessAppPlusHomeTmplS.homeTitle({
        link: UtilS.makeApiUrl('/:lang/@/product/list/:type', { lang: T.lang, type: 'recent' }),
        title: 'New Arrivals',
        sub_title: ET('ness::home::home_01'),
        title_color: NessCoreConstantS.colors.black,
        sub_title_color: NessCoreConstantS.colors.black,
      })}
      <div class="ness-recent-product__items-container swiper-container">
        <div class="ness-recent-product__items swiper-wrapper">
          ${strMap((product) => {
            return NessAppPlusProductTmplS.nessProductLazyLoadTmpl(product, is_mobile, 'swiper-slide');
          }, recent_products)}
        </div>
      </div>
    </div>
  `;
};
